import { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout';
import { Button, DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import * as svgIcons from '@progress/kendo-svg-icons';
import { logout } from '../../../features';

import styles from './header.module.scss';
import logo from './logo.svg';
import { useUserProfile } from '../../../hooks';
import { useUtilsDialog } from 'features/utils/contexts/UtilsDialogContext';
import { Input } from '@progress/kendo-react-inputs';
import { SvgIcon } from '@progress/kendo-react-common';
import { useFilters } from 'features/utils/contexts/SearchContext';

const dropDownItems = [{ text: 'Logout', icon: 'logout' }];

const Header: FunctionComponent = () => {
  const isAuthenticated = useIsAuthenticated();
  const userProfile = useUserProfile();
  const { openAddDialog } = useUtilsDialog();
  const { searchTerm, setSearchTerm } = useFilters();

  if (!isAuthenticated) return null;

  const theme = 'dark';

  const onItemClick = (evt: DropDownButtonItemClickEvent) => {
    switch (evt.item.text) {
      case 'Logout': {
        logout();
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <header className={styles.header}>
      <AppBar className={styles.appBar} themeColor={theme}>
        <AppBarSection>
          <NavLink to='/'>
            <img className={styles.logo} src={logo} alt='logo' />
          </NavLink>
        </AppBarSection>
        <AppBarSpacer />

        <AppBarSection className={styles.searchInputContainer}>
          <Input
            placeholder='Search...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value?.toString() || '')}
            className={styles.searchInput}
          />
          <SvgIcon icon={svgIcons.searchIcon} className={styles.searchIcon} />
        </AppBarSection>

        <AppBarSpacer />

        <AppBarSection>
          {userProfile?.isAdmin && (
            <Button
              themeColor='primary'
              fillMode='solid'
              icon='plus'
              onClick={openAddDialog}
              title='Add New Service'
              className={styles.addUtilButton}
            >
              Add App
            </Button>
          )}
        </AppBarSection>

        <AppBarSection>
          <DropDownButton
            icon='arrow-60-down'
            buttonClass={styles.dropdownIcon}
            themeColor='light'
            fillMode='link'
            rounded='small'
            text={userProfile?.name}
            popupSettings={{ popupClass: styles.dropdownPopup }}
            onItemClick={(evt) => onItemClick(evt)}
            items={dropDownItems}
          />
        </AppBarSection>
      </AppBar>
    </header>
  );
};

export default Header;
